module.exports = __webpack_public_path__ + "img/baseline-edit-24px.ea64341a.svg";